import { Box, Button, Grid } from "@mui/material";
import React from "react";
import "react-lazy-load-image-component/src/effects/blur.css";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PF } from "../../config";
import { useState } from "react";
import { useEffect } from "react";
import LoadingBox from "./Loading";
import CustomVideoPlayer from "./CustomVideoPlayer";
import { colors, radii } from "../../theme/designTokens";

export default function AboutUsVideo({ contentSettings }) {
  const [loadingMain, setLoadingMain] = useState(false);
  const [focusVid, setFocusVid] = useState({});
  const [videos, setVideos] = useState([]);
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const xlUp = useMediaQuery(theme.breakpoints.up("xl"));

  useEffect(() => {
    if (
      contentSettings &&
      contentSettings.aboutUsVideos &&
      contentSettings.aboutUsVideos.length > 0
    ) {
      const V = contentSettings.aboutUsVideos.find((v) => v.default);
      if (V) {
        setFocusVid(V);
      }
      setVideos(contentSettings.aboutUsVideos);
    }
  }, [contentSettings]);

  useEffect(() => {
    setLoadingMain(true);
    setTimeout(() => {
      setLoadingMain(false);
    }, 1000);
  }, []);
  return (
    <Box sx={{ width: "100%" }}>
      {loadingMain ? (
        <Box sx={{ overflow: "hidden" }}>
          <LoadingBox
            w={!smUp ? "60vw" : smUp && !mdUp ? 620 : mdUp && !xlUp ? 500 : 620}
            h={!smUp ? "350" : 500}
          />
        </Box>
      ) : (
        <>
          <Box sx={{ mb: 2 }}>
            {focusVid.src && focusVid.src !== "" && (
              <CustomVideoPlayer
                key={focusVid.src}
                url={
                  focusVid.externalLink
                    ? focusVid.src
                    : PF + "misc/" + focusVid.src
                }
                height={!smUp ? 220 : !mdUp ? 380 : !xlUp ? 340 : 420}
              />
            )}
          </Box>
          <Grid container spacing={1} justifyContent="center">
            {videos.length > 1 &&
              videos.map((x, i) => (
                <Grid item key={i}>
                  <Button
                    size="small"
                    variant={
                      x.src && x.src === focusVid.src ? "contained" : "outlined"
                    }
                    onClick={() => setFocusVid(x)}
                    sx={
                      x.src === focusVid.src
                        ? {
                            bgcolor: colors.primary,
                            borderRadius: radii.md,
                            "&:hover": { bgcolor: colors.primaryDark },
                          }
                        : {
                            color: colors.primary,
                            borderColor: colors.primary,
                            borderRadius: radii.md,
                          }
                    }
                  >
                    {i + 1}
                  </Button>
                </Grid>
              ))}
          </Grid>
        </>
      )}
    </Box>
  );
}
